<template>
    <c-nav-title>
        <slot/>
    </c-nav-title>
</template>
<script setup>
import {CNavTitle} from "@coreui/vue/dist/esm/components/nav/index.js";
</script>
